import { triggerSimpleAjax } from '../../helpers/httpHelper';
import { GET_CONSENT_FORM, GENERATE_CONSENT_OTP, SUBMIT_CONSENT_OTP } from '../../helpers/constants/apiUrl';
// Add the API endpoint for generating OTP
export function getConsentForm(req = '') {
    return new Promise((res, rej) => {
        const url = `${GET_CONSENT_FORM}${req}`;
        triggerSimpleAjax(
            url,
            'GET',
            {},
            (response) => {
                res(response);
            },
            (error) => {
                rej(error);
            }
        );
    });
}

// Function to generate OTP for consent code verification
export function generateConsentOtp(phone_number, account_number, ifsc_code, outlet_id) {
    return new Promise((res, rej) => {
        const payload = {
            phone_number: phone_number,
            type_of_request: "consent_code_verification",
            account_number:account_number,
            ifsc_code:ifsc_code,
            outlet_id
        };
        triggerSimpleAjax(
            GENERATE_CONSENT_OTP,
            'POST',
            payload,
            (response) => {
                res(response);
            },
            (error) => {
                rej(error);
            }
        );
    });
}

// Function to submit consent form
export function submitConsentForm({
    outlet_id,
    consent_status,
    phone_number,
    otp,
    decodedOutletId,
    rejection_reason,
    data // <-- added this new param
}) {
    return new Promise((res, rej) => {
        const url = SUBMIT_CONSENT_OTP;

        const payload = {
            outlet_id,
            consent_status,
            phone_number,
            otp: Number(otp),
            source: decodedOutletId ? decodedOutletId : 'sms',
            ...(rejection_reason && { rejection_reason }), // include only if exists
            ...(data && { data }) // include only if passed
        };

        triggerSimpleAjax(
            url,
            'POST',
            payload,
            (response) => res(response),
            (error) => rej(error)
        );
    });
}


